//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { PopoverMenu, Actions, ActionButton } from '@nextcloud/vue';
import ClickOutside from 'vue-click-outside';
import { getCurrentUser } from '@nextcloud/auth';
import UserRowMixin from '../../mixins/UserRowMixin';
export default {
  name: 'UserRowSimple',
  components: {
    PopoverMenu: PopoverMenu,
    ActionButton: ActionButton,
    Actions: Actions
  },
  directives: {
    ClickOutside: ClickOutside
  },
  mixins: [UserRowMixin],
  props: {
    user: {
      type: Object,
      required: true
    },
    loading: {
      type: Object,
      required: true
    },
    showConfig: {
      type: Object,
      required: true
    },
    userActions: {
      type: Array,
      required: true
    },
    openedMenu: {
      type: Boolean,
      required: true
    },
    feedbackMessage: {
      type: String,
      required: true
    },
    subAdminsGroups: {
      type: Array,
      required: true
    },
    settings: {
      type: Object,
      required: true
    }
  },
  computed: {
    userGroupsLabels: function userGroupsLabels() {
      return this.userGroups.map(function (group) {
        return group.name;
      }).join(', ');
    },
    userSubAdminsGroupsLabels: function userSubAdminsGroupsLabels() {
      return this.userSubAdminsGroups.map(function (group) {
        return group.name;
      }).join(', ');
    },
    usedSpace: function usedSpace() {
      if (this.user.quota.used) {
        return t('settings', '{size} used', {
          size: OC.Util.humanFileSize(this.user.quota.used)
        });
      }

      return t('settings', '{size} used', {
        size: OC.Util.humanFileSize(0)
      });
    },
    canEdit: function canEdit() {
      return getCurrentUser().uid !== this.user.id || this.settings.isAdmin;
    },
    userQuota: function userQuota() {
      if (this.user.quota.quota === 'none') {
        return t('settings', 'Unlimited');
      }

      if (this.user.quota.quota >= 0) {
        return OC.Util.humanFileSize(this.user.quota.quota);
      }

      return OC.Util.humanFileSize(0);
    }
  },
  methods: {
    hideMenu: function hideMenu() {
      this.$emit('hideMenu');
    },
    toggleEdit: function toggleEdit() {
      this.$emit('update:editing', true);
    }
  }
};